var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"property"},[_c('header',[_c('a',{attrs:{"href":"#back"},on:{"click":function($event){$event.preventDefault();return _vm.$router.go(-1)}}},[_c('img',{staticClass:"icon icon-shadow",attrs:{"src":require('@/assets/images/chevron_left.svg')}})])]),_c('section',{staticClass:"map"},[_c('gmap-map',{staticStyle:{"width":"100%","height":"100%"},attrs:{"center":_vm.center,"markers":_vm.markers,"zoom":18,"options":{
       zoomControl: true,
       mapTypeControl: false,
       scaleControl: false,
       streetViewControl: false,
       rotateControl: false,
       fullscreenControl: true,
       disableDefaultUi: false
     }}},_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position,"clickable":false,"draggable":false},on:{"click":function($event){_vm.center=m.position}}})}),1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }